export default __webpack_public_path__ + "static/media/1_Still.f6579d95.jpg";